import { AlertTriangle, Info } from 'lucide-react';
import { cn } from '@/lib/cn';
import type { Nudge } from './api';

/**
 * Deterministic completeness nudges (⚠ / ℹ). Deliberately styled unlike AI
 * suggestion chips (✨) so a rule-based reminder is never mistaken for an AI
 * suggestion, or for a safety alert — they never block approval.
 */
export function NudgeList({ nudges, className }: { nudges: Nudge[]; className?: string }) {
  if (!nudges.length) return null;
  return (
    <ul className={cn('flex flex-col gap-1', className)} aria-label="Things you may want to check">
      {nudges.map((nudge) => {
        const Icon = nudge.severity === 'warn' ? AlertTriangle : Info;
        return (
          <li
            key={nudge.key}
            title={nudge.clinicalBasis}
            className={cn(
              'flex items-start gap-1.5 rounded px-2 py-1 text-[12px]',
              nudge.severity === 'warn' ? 'bg-warn-soft text-warn-ink' : 'bg-info-soft text-info-ink'
            )}
          >
            <Icon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
            <span>{nudge.message}</span>
          </li>
        );
      })}
    </ul>
  );
}
